import { ModalWindow } from '@cian/ui-kit/modal';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { SORT_TYPE_BUTTONS } from './buttons';
import * as styles from './styles.css';
import { useFavoritesUxfeedbackCampaign } from '../../hooks/uxfeedback';
import { EOrderField } from '../../types/filters';

interface IDealTypeSortModal {
  orderField?: EOrderField | null;
  open: boolean;
  setFilterOrder(orderField: EOrderField | null): void;
  closeSort(): void;
}

export const DealTypeSortModal: React.FC<IDealTypeSortModal> = ({ orderField, open, setFilterOrder, closeSort }) => {
  const { sendFavoritesUxfeedbackCampaign } = useFavoritesUxfeedbackCampaign();

  const setFiltersOrderType = (order: EOrderField) => {
    setFilterOrder(order);
    closeSort();
    sendFavoritesUxfeedbackCampaign();
  };

  return (
    <ModalWindow
      title="Сортировка"
      content={
        <div className={styles['sort-container']}>
          <ul className={styles['sort-list']}>
            {SORT_TYPE_BUTTONS.map(button => (
              <li
                key={button.value}
                className={styles['sort-list-item']}
                onClick={() => {
                  setFiltersOrderType(button.value);
                }}
              >
                {button.label}
                {button.value === orderField && <IconFunctionalSuccess16 color="icon-main-default" />}
              </li>
            ))}
          </ul>
        </div>
      }
      open={open}
      onClose={closeSort}
    />
  );
};
